<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="分账申请单详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="detailInfo.divideApplyNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <btns-operate
          :current="detailInfo"
          @success="handleOperateResults"
        />
      </div>
      <div v-loading="loading">
        <div class="main-cont">
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="statusColorFilters(detailInfo.approvalStatus)"
                :status="detailInfo.approvalStatusDesc"
                size="100px"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo">
                <template #payReason>
                  <jr-tooltip :content="detailInfo.payReason || '-'" />
                </template>
                <template #orderNumber>
                  <jr-tooltip :content="detailInfo.orderNumber" type="popover" />
                </template>
              </jr-col>
              <jr-col :data-show="secondCol" :data="detailInfo" />
              <jr-col :data-show="thirdCol" :data="detailInfo" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">申请分账方案</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.divideDetail || [])"
              :tableColumn="divideDetailTableColumn"
            />
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联的应收单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.receives || [])"
              :tableColumn="receivesTableColumn"
            />
          </div>
        </div>
      </div>
    </finance-drawer>

    <!-- 详情 -->
    <receive-detail
      :visible.sync="isReceiveDetailShow"
      :receive-no.sync="receiveNo"
    />
  </div>
</template>
<script>
import receiveDetail from '../../../receivables/components/receive-detail';
import { getDivideApplyDetail } from '@/api/receivables/sub-account';
import { setStatusColor } from '@/filters/index';
import BtnsOperate from './btns-operate';

export default {
  props: {
    divideNo: {
      type: String,
      default: '',
    },
    viewStatusType: {
      type: String,
      default: 'approvalStatusType',
    },
  },
  components: { BtnsOperate, receiveDetail },
  data() {
    return {
      detailInfo: {},
      loading: false,
      isReceiveDetailShow: false, // 详情弹窗
      receiveNo: '', // 应收单编号
      // 基础信息
      firstCol: [
        { label: '业务订单号:', prop: 'orderNumber' },
        { label: '付款原因:', prop: 'payReason', slotName: 'payReason' },
      ],
      secondCol: [
        { label: '申请分账金额:', prop: 'divideAmount', filters: 'toFenThousandsAndFloat(¥)', className: 'detail-amount_num' },
        { label: '申请时间:', prop: 'createTime', filters: 'formatTime' },
        { label: '审核时间:', prop: 'approvalTime', filters: 'formatTime' },
      ],
      thirdCol: [
        { label: '归属业务:', prop: 'busiSourceDesc' },
        { label: '申请人:', prop: 'createUser' },
        { label: '操作人:', prop: 'approvalUser' },
      ],
      // 关联的应收单
      receivesTableColumn: [
        {
          label: '应收单编号',
          prop: 'receiveNo',
          permission: 'FWS-SFKGL-YSD-XQ',
          click: (row) => {
            this.handleReceiveDetail(row);
          },
        },
        { label: '业务订单编号', prop: 'orderNumber' },
        { label: '应收类型', prop: 'typeDesc' },
        { label: '应收金额(元)', prop: 'shouldRecAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '实收金额(元)', prop: 'realAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '待收金额(元)', prop: 'waitRecAmount', filterName: 'toFenThousandsAndFloat' },
        {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
      ],
      // 申请分账方案
      divideDetailTableColumn: [
        { label: '客户编号', prop: 'businessNo' },
        { label: '客户名称', prop: 'businessName' },
        { label: '钱包编号', prop: 'accountNo' },
        { label: '开户名', prop: 'accountName' },
        { label: '分账金额(元)', prop: 'divideAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '是否可提现', prop: 'enableWithdrawDesc' },
      ],
    };
  },
  watch: {
    divideNo: {
      deep: true,
      handler() {
        if (this.divideNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    statusColorFilters(status) {
      return setStatusColor(status, 'subStatus');
    },
    // 通过/驳回操作返回结果
    handleOperateResults() {
      this.getDivideApplyDetail();
      this.$emit('refresh');
    },
    // 应收单详情
    handleReceiveDetail(row) {
      this.receiveNo = row?.receiveNo || '';
      this.isReceiveDetailShow = true;
    },
    handlePictureCardPreview(file, index, gallery) {
      const viewer = this.$refs[gallery].$viewer;
      viewer.view(index);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.isReceiveDetailShow = false;
        this.getDivideApplyDetail();
      });
    },
    // 获取付款管理详情接口
    async getDivideApplyDetail() {
      try {
        this.detailInfo = {};
        if (!this.divideNo) {
          this.$message({
            message: '分账编号不能为空！！',
            type: 'warning',
          });
          return;
        }
        this.loading = true;
        const res = await getDivideApplyDetail({ divideNo: this.divideNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .detail-item-div {
    font-size: 12px !important;
  }
}
.table-button {
  margin-bottom: 0;
}
</style>

